import { Reservation } from './';

export const RESERVATION: Reservation[] = [];
